module.exports = __webpack_public_path__ + "ae6369a0d667b49cba72ef7841f78a24.svg";